import React from "react";
import { fmt } from "../../../../../utils/Util";

function ProjectPhaseDays({ carDays }) {
    // group carDays by date and sort dates ascending
    const groupedByDate = (Array.isArray(carDays) ? carDays : []).reduce((acc, cd) => {
        const d = cd.date || "";
        if (!acc[d]) acc[d] = [];
        acc[d].push(cd);
        return acc;
    }, {});
    const sortedDates = Object.keys(groupedByDate).sort((a, b) => {
        if (!a) return 1;
        if (!b) return -1;
        return a.localeCompare(b); // ISO strings sort correctly
    });

    // Calculate summary statistics
    const totalDays = sortedDates.length;
    const totalKmAll = (Array.isArray(carDays) ? carDays : []).reduce((sum, cd) => sum + (typeof cd.km !== "undefined" ? cd.km : 0), 0);

    // Group km by car (licenseNumber)
    const kmByCar = (Array.isArray(carDays) ? carDays : []).reduce((acc, cd) => {
        const license = cd.licenseNumber || '—';
        if (!acc[license]) acc[license] = 0;
        acc[license] += typeof cd.km !== "undefined" ? cd.km : 0;
        return acc;
    }, {});
    const carKmEntries = Object.entries(kmByCar).sort((a, b) => b[1] - a[1]); // sort by km descending

    return (
        <div className="car-day-section">

            {/* Summary Section */}
            <div className="car-days-summary">
                <div className="summary-stat">
                    <span className="summary-label">Munkanapok:</span>
                    <span className="summary-value">{totalDays}</span>
                </div>
                <div className="summary-stat">
                    <span className="summary-label">Össz km:</span>
                    <span className="summary-value">{totalKmAll}</span>
                </div>
                {sortedDates.length > 0 && (
                    <div className="summary-stat km-breakdown">
                        <span className="summary-label">Autók km-ja:</span>
                        <div className="km-by-car-list">
                            {carKmEntries.map(([license, km]) => (
                                <div key={license} className="km-by-car-item">
                                    <span className="car-license">{license}</span>
                                    <span className="car-km-value">{km} km</span>
                                </div>
                            ))}
                        </div>
                    </div>)}
            </div>
            {sortedDates.length > 0 && (
                <div className="car-days-wrapper">
                    {sortedDates.map((date) => {
                        const totalKm = groupedByDate[date].reduce((sum, cd) => sum + (typeof cd.km !== "undefined" ? cd.km : 0), 0);
                        return (
                            <div key={date} className="car-day-date-group">
                                <div className="car-day-group-date-header">
                                    <span>{fmt(date)}</span>
                                    {totalKm > 0 && <span className="total-km-badge">{totalKm} km</span>}
                                </div>
                                <div className="car-day-items-wrapper">
                                    {groupedByDate[date].map((cd, ci) => (
                                        <div key={`${cd.carId || 'car'}-${cd.date || ci}`} className="car-day-item">
                                            <div className="car-day-main">
                                                <span className="car-day-license">{cd.licenseNumber || '—'}</span>
                                                <span className="car-day-driver">{cd.driverEmployeeName || '—'}</span>
                                            </div>
                                            {typeof cd.km !== "undefined" && (
                                                <span className="car-day-km">{cd.km} km</span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )
            }
        </div >
    )
}

export default ProjectPhaseDays
